import React from 'react';
import PropTypes from 'prop-types';

import { useGetFulfillmentPlanAmountSummary } from '../hooks/use-calculate-amount-summary';
import CurrencyColumn from '../../../components/columns/currency-column';
import { messages } from './messages';

const OrderTotalColumn = ({ fulfillmentPlanId }) => {
  const amountSummary = useGetFulfillmentPlanAmountSummary(fulfillmentPlanId);
  if (!amountSummary?.total) {
    return '';
  }
  const { value, code } = amountSummary.total;

  return <CurrencyColumn currencyCode={code} value={value} />;
};

OrderTotalColumn.propTypes = {
  fulfillmentPlanId: PropTypes.string.isRequired,
};

export const OrderTotal = {
  getMessageDescriptor: () => messages.orderTotal,
  id: 'order-total',

  render: (data, { isFirstOfType = true } = {}) => {
    if (!isFirstOfType) {
      return null;
    }

    return <OrderTotalColumn fulfillmentPlanId={data.id} />;
  },
};
